import DocumentacionCompleta from "../Formularios/DocumentacionCompleta";
import { PreviewDocumentV2, printDocumentV2 } from "./printDocumentV2";
import "./formulariosV2.css";

const exportDocuments = (type, documents) =>
  printDocumentV2(type, type === "complete" ? documents : documents[type]);

export default function DocumentacionCompletaV2() {
  return (
    <DocumentacionCompleta
      renderPreview={PreviewDocumentV2}
      exportDocuments={exportDocuments}
      backHref="/formularios-v2"
      versionLabel="V2"
    />
  );
}
